import * as React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

export const PageLoader: React.FC<{}> = _ => 
    <Box position="absolute" top="30%" left={0} right={0} textAlign="center">
        <CircularProgress size={60} thickness={4} />
    </Box>;